<template>
  <div class="uk-position-relative">
    <div v-html="resultsHtml"></div>
    <div class="uk-overlay-default uk-position-cover uk-animation-fade uk-animation-fast" v-if="isLoading">
    </div>
  </div>
</template>

<script>
import {onMounted, ref} from 'vue'
import {sfUtil} from '../../util'

export default {
  name: "SearchResultsApp",
  props: {
    initialResultsHtml: String
  },
  components: {},

  setup(props, context) {

    const resultsHtml = ref('')
    const isLoading = ref(false)

    onMounted(() => {
      // console.log('SearchResultsApp Mounted!');
      document.addEventListener('searchPredicateChanged', (e) => {
        updateResults()
      })
    })

    const getStandaloneResultsUrl = (location) => {
      let url = new URL(location)

      //remove paging from pathname
      url.pathname = url.pathname.replace(sfUtil.sfPathnamePagingRegex, '') + '/StandaloneResults'

      return url.toString()
    }

    const updateResults = () => {
      isLoading.value = true

      if (!sfUtil.hasActiveFiltering()) {

        if (!props.initialResultsHtml) {
          window.location.reload()
        } else {
          setTimeout(() => {
            resultsHtml.value = props.initialResultsHtml
            isLoading.value = false
          }, 300)
        }


      } else {
        fetch(getStandaloneResultsUrl(window.location))
            .then(r => {
              r.text().then(t => {
                resultsHtml.value = t
                setTimeout(() => {
                  if (typeof initMap === "function") {
                    setTimeout(initMap, 0);
                  }
                }, 0)
              })
            }).catch(e => {
          console.log({e})
        }).finally(() => {
          isLoading.value = false
        })
      }
    }

    return {
      resultsHtml,
      isLoading,
    }

  }
}
</script>

<style lang="scss" scoped>


</style>

